<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{copyRightYear}}
<!--              © ADP.-->
            </div>
<!--            <div class="col-sm-6">-->
<!--                <div class="text-sm-right d-none d-sm-block">-->
<!--                    Design & Develop by Whiztec-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</footer>
